import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/rota-interna');
  }
}

export default new Service();
